import React, {useContext, useEffect, useState} from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Preloader from "./components/layouts/Preloader";
import Dashboard from "./components/pages/Dashboard";
import Accordions from "./components/pages/Accordions";
import Addproduct from "./components/pages/Addproduct";
import Alerts from "./components/pages/Alerts";
import Animations from "./components/pages/Animations";
import Badges from "./components/pages/Badges";
import Basictables from "./components/pages/Basictables";
import Breadcrumbs from "./components/pages/Breadcrumbs";
import Buttons from "./components/pages/Buttons";
import Cards from "./components/pages/Cards";
import Chartjs from "./components/pages/Chartjs";
import Chat from "./components/pages/Chat";
import Cropper from "./components/pages/Cropper";
import Customerlist from "./components/pages/Customerlist";
import Customeredit from "./components/pages/Customeredit";
import Customerreview from "./components/pages/Customerreview";
import Datatables from "./components/pages/Datatables";
import Draggables from "./components/pages/Draggables";
import Email from "./components/pages/Email";
import Flaticons from "./components/pages/Flaticons";
import Fontawesome from "./components/pages/Fontawesome";
import Formelements from "./components/pages/Formelements";
import Formlayouts from "./components/pages/Formlayouts";
import Formvalidation from "./components/pages/Formvalidation";
import Formwizard from "./components/pages/Formwizard";
import Googlemaps from "./components/pages/Googlemaps";
import Invoicedetail from "./components/pages/Invoicedetail";
import Invoicelist from "./components/pages/Invoicelist";
import Materialize from "./components/pages/Materialize";
import Menucatalogue from "./components/pages/Menucatalogue";
import Menugrid from "./components/pages/Menugrid";
import Modals from "./components/pages/Modals";
import Googlechart from "./components/pages/Googlechart";
import Orders from "./components/pages/Orders";
import Pagination from "./components/pages/Pagination";
import Preloaders from "./components/pages/Preloaders";
import Productdetail from "./components/pages/Productdetail";
import Progressbars from "./components/pages/Progressbars";
import Rangeslider from "./components/pages/Rangeslider";
import Rating from "./components/pages/Rating";
import Sales from "./components/pages/Sales";
import Sliders from "./components/pages/Sliders";
import Socialactivity from "./components/pages/Socialactivity";
import Sweetalerts from "./components/pages/Sweetalerts";
import Tabs from "./components/pages/Tabs";
import Toast from "./components/pages/Toast";
import Todolist from "./components/pages/Todolist";
import Tour from "./components/pages/Tour";
import Typography from "./components/pages/Typography";
import Vectormaps from "./components/pages/Vectormaps";
import Widgets from "./components/pages/Widgets";
import Clientmanagement from "./components/pages/Clientmanagement";
import Comingsoon from "./components/pages/Comingsoon";
import Defaultlogin from "./components/pages/Defaultlogin";
import Defaultregister from "./components/pages/Defaultregister";
import Error from "./components/pages/Error";
import Invoice from "./components/pages/Invoice";
import Lockscreen from "./components/pages/Lockscreen";
import Modallogin from "./components/pages/Modallogin";
import Modalregister from "./components/pages/Modalregister";
import Portfolio from "./components/pages/Portfolio";
import Userprofile from "./components/pages/Userprofile";
import Webanalytics from "./components/pages/Webanalytics";
import Userlist from "./components/pages/Userlist";
import Useredit from "./components/pages/Useredit";
import Permission from "./components/pages/Permission";
import Orderedit from "./components/pages/Orderedit";
import Setting from "./components/pages/Setting";
import Banner from "./components/pages/Banner";
import Settingedit from "./components/pages/Settingedit";
import Banneredit from "./components/pages/Banneredit";
import Login from "./components/pages/Login";
import Salesreportdate from "./components/pages/Salesreportdate";
import Pendingorders from "./components/pages/Pendingorder";
import Payment from "./components/pages/Payment";
import Paymentedit from "./components/pages/Paymentedit";
import Addorder from "./components/pages/Addorder";
import AuthContext from "./context/auth-context";
import CurrierPrice from "./components/pages/Currierprice";
import CurrierCompany from "./components/pages/Curriercompany";
import IncomingInvoice from "./components/pages/Incominginvoice";
import IncomingInvoiceEdit from "./components/pages/Incominginvoiceedit";
import Addincominginvoice from "./components/pages/Addincominginvoice";
import Currierpriceedit from "./components/pages/Currierpriceedit";
import Curriercompanyedit from "./components/pages/Curriercompanyedit";
import Category from "./components/pages/Category";
import Categoryedit from "./components/pages/Categoryedit";
import ProductReview from "./components/pages/Productreview";
import ProductReviewedit from "./components/pages/Productreviewedit";
import Productlistedit from "./components/pages/Productlistedit";
import Productlist from "./components/pages/Productlist";
import FlashSaleList from "./components/pages/Flashsale";
import FlashSaleedit from "./components/pages/Flashsaleedit";
import Stock from "./components/pages/Stock";
import Forgotpassword from "./components/pages/Forgotpassword";
import VerifyOtp from "./components/pages/Verifyotp";
import ResetPassword from "./components/pages/Resetpassword";
import Salesprofitreport from "./components/pages/Salesprofitreport";
import Salesproductreport from "./components/pages/Salesproductsreport";
import Salesorderreport from "./components/pages/Salesorderreport";
import Salespublisherwiseproductreport from "./components/pages/Salespublisherwiseproductreport";
import Salesstudentsreport from "./components/pages/Salesstudentsreport";
import Medium from "./components/pages/Medium";
import Mediumedit from "./components/pages/Mediumedit";
import Subject from "./components/pages/Subject";
import Subjectedit from "./components/pages/Subjectedit";
import Publisher from "./components/pages/Publisher";
import Publisheredit from "./components/pages/Publisheredit";
import Dashboardreport from "./components/pages/Dashboardreport";
import Gdn from "./components/pages/Gdn";
import Addgdn from "./components/pages/Addgdn";
import GdnEdit from "./components/pages/Gdnedit";
import Billprint from "./components/pages/Billprint";
import Ordersnew from "./components/pages/Ordersnew";
import Profitreport from "./components/pages/Profitreport";
import SalesTotalReport from "./components/pages/Salestotalreport";
import Stocksummary from "./components/pages/Stocksummary";
import Salestotalstockreport from "./components/pages/Salestotalstockreport";

function App() {

  let ctx = useContext(AuthContext);
const authPermission = localStorage.getItem("PermissionDetails");
  
    const [pathHide, setHidePath] = useState(true);
    const [mPathHide, setHideMPath] = useState(true);

    // Helper function to get default redirect path based on user access level
    const getDefaultRedirectPath = () => {
      if (authPermission) {
        try {
          const permissions = JSON.parse(authPermission);
          const userAccessLevel = permissions[0]?.access_level?.access_level;
          if (userAccessLevel === "SALES_USER" || userAccessLevel === "STORE_USER") {
            return "/orders";
          }
        } catch (error) {
          console.error("Error parsing permission details:", error);
        }
      }
      return "/dashboard-report";
    };
  
    useEffect(() => {
      if(authPermission){
        JSON.parse(authPermission).forEach(function (loca) {
    
          if (
            loca.access_level.access_level === "ADMIN"
          ) {
            setHidePath(false);
          }

          if (
            loca.access_level.access_level === "SUPER_ADMIN"
          ) {
            setHideMPath(false);
          }

          if (
            loca.access_level.access_level === "STORE_USER"
          ) {
            setHideMPath(false);
          }

          if (
            loca.access_level.access_level == "SALES_USER"
          ) {
            setHideMPath(false);
          }
        });
      }

    }, [authPermission]);
    
  return (
    <Router>
      <Preloader />
      <Switch>
        {/* <Redirect from="/" exact to="/login" /> */}
        {/* <Route path="/login" component={Login} />
        <Route path="/dashboard" component={Dashboard} /> */}
{/* {ctx.isLoggedIn && <Redirect exact from="/" to="/dashboard" />}
{!ctx.isLoggedIn && <Redirect exact from="/" to="/login" />} */}
        {/* <Redirect from="/login" exact to="/dashboard" /> */}
        <Route exact path="/">
          {ctx.isLoggedIn ? <Redirect to={getDefaultRedirectPath()} /> : <Redirect to="/login" />}
        </Route>
        {/* {!ctx.isLoggedIn & <Route path="/login" component={Login} />} */}
        <Route path="/login">
          {ctx.isLoggedIn ? <Redirect to={getDefaultRedirectPath()} /> : <Login />}
        </Route>
        {/* Other routes */}
        {/* <Route path="/dashboard">
          {ctx.isLoggedIn ? <Dashboard /> : <Redirect to="/login" />}
        </Route> */}
        {!ctx.isLoggedIn && (
          <>
          <Route path="/forgotpassword" component={Forgotpassword} />
          <Route path="/password-reset-validate-code" component={VerifyOtp} />
          <Route path="/password-reset-set-password" component={ResetPassword} />
          </>
          
        )}

        {/* {ctx.isLoggedIn && <Route path="/dashboard" component={Dashboard} />} */}
        {/* <Redirect from="/" to="/dashboard" /> */}
        {ctx.isLoggedIn ? (
          <>
              <Route path="/accordions" component={Accordions} />
              <Route path="/add-product" component={Addproduct} />
              <Route path="/alerts" component={Alerts} />
              <Route path="/animations" component={Animations} />
              <Route path="/badges" component={Badges} />
              <Route path="/basic-tables" component={Basictables} />
              <Route path="/breadcrumbs" component={Breadcrumbs} />
              <Route path="/buttons" component={Buttons} />
              <Route path="/cards" component={Cards} />
              <Route path="/chartjs" component={Chartjs} />
              <Route path="/chat" component={Chat} />
              <Route path="/cropper" component={Cropper} />
              <Route path="/customer-list" component={Customerlist} />
              <Route path="/customer-edit/:customerID" component={Customeredit} />
              <Route path="/customer-review" component={Customerreview} />
              <Route path="/data-tables" component={Datatables} />
              <Route path="/draggables" component={Draggables} />
              <Route path="/email" component={Email} />
              <Route path="/flaticons" component={Flaticons} />
              <Route path="/fontawesome" component={Fontawesome} />
              <Route path="/form-elements" component={Formelements} />
              <Route path="/form-layouts" component={Formlayouts} />
              <Route path="/form-validation" component={Formvalidation} />
              <Route path="/form-wizard" component={Formwizard} />
              <Route path="/google-maps" component={Googlemaps} />
              <Route path="/invoice-detail" component={Invoicedetail} />
              <Route path="/invoice-list" component={Invoicelist} />
              <Route path="/materialize" component={Materialize} />
              <Route path="/menu-catalogue" component={Menucatalogue} />
              <Route path="/menu-grid" component={Menugrid} />
              <Route path="/product-list" component={Productlist} />
              <Route path="/modals" component={Modals} />
              <Route path="/google-chart" component={Googlechart} />
              <Route path="/orders" component={Orders} />
              <Route path="/pagination" component={Pagination} />
              <Route path="/preloaders" component={Preloaders} />
              <Route path="/product-detail" component={Productdetail} />
              <Route path="/progress-bars" component={Progressbars} />
              <Route path="/range-slider" component={Rangeslider} />
              <Route path="/rating" component={Rating} />
              <Route path="/sales" component={Sales} />
              <Route path="/sliders" component={Sliders} />
              <Route path="/social-activity" component={Socialactivity} />
              <Route path="/sweet-alerts" component={Sweetalerts} />
              <Route path="/tabs" component={Tabs} />
              <Route path="/toast" component={Toast} />
              <Route path="/todo-list" component={Todolist} />
              <Route path="/tour" component={Tour} />
              <Route path="/typography" component={Typography} />
              <Route path="/vector-maps" component={Vectormaps} />
              <Route path="/widgets" component={Widgets} />
              <Route path="/client-management" component={Clientmanagement} />
              <Route path="/coming-soon" component={Comingsoon} />
              <Route path="/default-login" component={Defaultlogin} />
              <Route path="/default-register" component={Defaultregister} />
              <Route path="/error" component={Error} />
              <Route path="/invoice" component={Invoice} />
              <Route path="/lock-screen" component={Lockscreen} />
              <Route path="/modal-login" component={Modallogin} />
              <Route path="/modal-register" component={Modalregister} />
              <Route path="/portfolio" component={Portfolio} />
              <Route path="/user-profile" component={Userprofile} />
              <Route path="/web-analytics" component={Webanalytics} />
              <Route path="/user-edit/:adminID" component={Useredit} />
              <Route path="/category" component={Category} />
              <Route
                path="/edit-category/:categoryId"
                component={Categoryedit}
              />
              <Route path="/subject" component={Subject} />
              <Route
                path="/edit-subject/:subjectId"
                component={Subjectedit}
              />
              <Route path="/medium" component={Medium} />
              <Route
                path="/edit-medium/:mediumId"
                component={Mediumedit}
              />
              <Route path="/publisher" component={Publisher} />
              <Route
                path="/edit-publisher/:publisherId"
                component={Publisheredit}
              />
              <Route path="/stock" component={Stock} />
              <Route path="/stock-summary" component={Stocksummary} />
              <Route path="/flash-sale" component={FlashSaleList} />
              <Route
                path="/flash-sale-edit/:flashSaleID"
                component={FlashSaleedit}
              />
              <Route path="/edit-product/:productID" component={Productlistedit} />
              <Route path="/edit-order/:orderID" component={Orderedit} />
              <Route path="/banner" component={Banner} />
              <Route path="/banner-edit/:bannerID" component={Banneredit} />
              <Route path="/dashboard-report" component={Dashboardreport} />
              <Route path="/gdn" component={Gdn} />
              <Route path="/add-gdn" component={Addgdn}/>
              <Route path="/gdn-edit/:gdnID" component={GdnEdit}/>
              <Route path="/grn" component={IncomingInvoice} />
              <Route path="/add-grn" component={Addincominginvoice}/>
              <Route path="/grn-edit/:grnID" component={IncomingInvoiceEdit}/>
              <Route path="/product-review" component={ProductReview} />
              <Route
                path="/product-review-edit/:reviewID"
                component={ProductReviewedit}
              />
              <Route path="/sales-profit-report" component={Salesprofitreport} />
              <Route path="/sales-product-report" component={Salesproductreport} />
              <Route path="/sales-order-report" component={Salesorderreport} />
              <Route path="/sales-students-report" component={Salesstudentsreport} />
              <Route path="/sales-total-report" component={SalesTotalReport} />
              <Route path="/sales-total-stock-report" component={Salestotalstockreport} />


            <div hidden={mPathHide}>
              <Route path="/currier-price" component={CurrierPrice} />
              <Route path="/currier-price-edit/:currierPriceID" component={Currierpriceedit}/>
              <Route path="/currier-company" component={CurrierCompany} />
              <Route path="/currier-company-edit/:cCompanyID" component={Curriercompanyedit}/>
              <Route path="/sales-publisher-products-report" component={Salespublisherwiseproductreport} />
              <Route path="/salesreport-date" component={Salesreportdate} />
              <Route path="/pendingorder" component={Pendingorders} />
              <Route path="/payment" component={Payment} />
              <Route path="/payment-edit/:paymentID" component={Paymentedit} />
              <Route path="/add-order" component={Addorder} />
              <Route path="/setting-edit/:settingID" component={Settingedit} />
              <Route path="/setting" component={Setting} />
              <Route path="/permission" component={Permission} />
              <Route path="/bill-print" component={Billprint} />
              <Route path="/user-list" component={Userlist} />
            </div>
            <div hidden={pathHide}>
              <Route path="/profit-report" component={Profitreport} />
            </div>
          </>
          
        ): (
          <Route path="/login" component={Login}/>
        )}

        {/* {ctx.isLoggedIn ? (
          <Redirect from="/" to="/dashboard" />
        ) : (
          <Route>
            <Redirect from="/" to="/login" />
            <Route path="/" component={Login} />
          </Route>
        )} */}
        <Redirect to={ctx.isLoggedIn ? getDefaultRedirectPath() : "/login"} />
      </Switch>
    </Router>
  );
}

export default App;
